import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { search } from '@debbie/common/dist/util';
import { selectUpdateTypes } from '@debbie/cortex/dist/update-types/selectors';
import CreateUpdateTypeModal from '../CreateUpdateTypeModal';
import { Button, Input, Panel } from '..';
import UpdateType from './UpdateType';
import { sortBy } from '@debbie/common/dist/economy/helpers/utils';
import { PlusCircle } from '../Icons';
const onDragStart = (event, updateType) => {
    event.dataTransfer.setData('application/reactflow', JSON.stringify(updateType));
    event.dataTransfer.effectAllowed = 'move';
};
const AddUpdate = (props) => {
    const updateTypes = useSelector(selectUpdateTypes);
    const lang = useSelector((s) => s.lang);
    const [query, setQuery] = useState('');
    const [newUpdateTypeModalOpen, setNewUpdateTypeModalOpen] = useState(false);
    const updateTypesRes = useMemo(() => {
        return (updateTypes &&
            (query != ''
                ? search(updateTypes, (updateType) => {
                    var _a;
                    return (((_a = lang.updateTypes[updateType.updateTypeId]) !== null && _a !== void 0 ? _a : updateType.label) + updateType.description).toLocaleLowerCase();
                }, query, { returnMeta: true })
                : updateTypes.map((uT) => ({ item: uT, score: 0 }))));
    }, [updateTypes, query]);
    return (React.createElement(AddUpdatePanel, null,
        newUpdateTypeModalOpen && (React.createElement(CreateUpdateTypeModal, { onCreate: () => {
                setNewUpdateTypeModalOpen(false);
            }, onToggle: () => setNewUpdateTypeModalOpen(!newUpdateTypeModalOpen) })),
        React.createElement(Input, { placeholder: lang.workflows.searchUpdates, value: query, onChange: (e) => {
                setQuery(e.target.value);
            }, autofocus: true }),
        React.createElement(Button, { block: true, onClick: () => setNewUpdateTypeModalOpen(!newUpdateTypeModalOpen) },
            React.createElement(PlusCircle, null),
            " ",
            lang.updateTypesSettings.createNewUpdateType),
        React.createElement("br", null),
        updateTypesRes && (React.createElement(UpdateTypesList, null,
            updateTypesRes.length === 0 && (React.createElement("h3", null, lang.workflows.noUpdatesToShow)),
            updateTypesRes
                .sort(sortBy((a, b) => {
                return Math.abs(b.score - a.score) < 0.05
                    ? (b.item.procedureEnabled ? 1 : 0) -
                        (a.item.procedureEnabled ? 1 : 0)
                    : a.score - b.score;
            }, (a, b) => {
                return (new Date(b.item.createdAt).getTime() -
                    new Date(a.item.createdAt).getTime());
            }))
                .map((x) => x.item)
                .map((updateType) => {
                return (React.createElement(UpdateBox, { key: updateType.updateTypeId, onDragStart: (event) => onDragStart(event, updateType), draggable: true },
                    React.createElement(UpdateType, { updateType: updateType, workflowId: props.workflowId })));
            })))));
};
export default AddUpdate;
const UpdateBox = styled.div `
  border: 1px solid #ccc;
  padding: 10px 20px;
  border-radius: 3px;
  margin-bottom: 10px;
  cursor: grab;
`;
const BASE_HEIGHT = 340;
const UpdateTypesList = styled.div `
  overflow-y: scroll;
  max-height: calc(100vh - ${BASE_HEIGHT + 136}px);
`;
const AddUpdatePanel = styled(Panel) `
  position: absolute;
  width: 300px;
  z-index: 9;
  right: 40px;
  top: 80px;

  .body {
    max-height: calc(100vh - ${BASE_HEIGHT}px);
  }
`;
//# sourceMappingURL=AddUpdate.js.map